import PropTypes from 'prop-types';
import React from 'react';
import { NavLink } from 'fluxible-router';
import { parse } from 'url';

const CategoryCardLink = ({ article, children }) => {
  const url = article.external ? article.url : parse(article.url).pathname;

  return (
    <NavLink href={url} followLink={article.forceFullReload}>
      {children}
    </NavLink>
  );
};

CategoryCardLink.propTypes = {
  article: PropTypes.object,
  children: PropTypes.node
};

export default CategoryCardLink;
